import * as actionTypes from '../actions/actionTypes';

const initialState = {
    opened: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.leftMenu.LEFT_MENU_STATUS:
            return {
                ...state,
                opened: action.opened,
            };
        default:
            return state;
    }
};

export default reducer;
